/***************************************************************
5/22/2017
Alexander Self
Timesheet Create
- Timesheet form
12.6.21: Added paycodes
***************************************************************/
import React from 'react';
import moment from 'moment';
import { TextInput, Select, NumberInput, SelectCostCenter, SelectField, SelectBlock,
  SelectEquipment, AutoComplete, SelectSubAccount, DatePicker2, TimePicker2 } from '../../inputs';
import { 
  LOCATIONS, 
  GRADES, 
  SHIFTS, 
  DIFFERENTIAL_SLOT,
  DAYS_FOR_ADMINS 
} from '../../../constants';
import { getSelectedValue, generateGUID, mapEquipmentForAutoComplete,
  onDummyComplete, handleWorkPerformed, setPaycodeInWorkPerformed,
  setCCSubInWorkPerformed, handleEquipmentNo } from '../../../utils';
import WorkTable from './add_work_table';
const $ = window.$;

const TimesheetForm = ({ fields, blocks, costCenters, details, equipmentNo, equipmentTrailerNo,
  subAccounts, paycodes, user, workPerformed, addWork, editWork, removeWork, payPeriodStartDate, payPeriodEndDate,
  fetchSubAccounts, fetchFieldsByLoc, fetchBlocksByField, selectCostCenterByLocation, editWorkRecord,
  prevPPStartDate, prevPPEndDate }) => {

  function packageWorkPerformed(callback) {
    // handles form checks: hours=0.00, workPerformed != '', paycode > 13 no hours, etc
    let { hours, trainer, check } = handleWorkPerformed();
    if (!check) return;
    // Make sure employees select the full equipment no with description

    let equipCheck = handleEquipmentNo('equipmentNo', equipmentNo);
    if (!equipCheck) return;

    callback({
      workId: generateGUID(),
      tempGrade: getSelectedValue('tempGrade'),
      costCenterCode: getSelectedValue('costCenterCode'),
      subAccount: getSelectedValue('subAccount'),
      paycode: getSelectedValue('paycode'),
      field: getSelectedValue('field'),
      block: getSelectedValue('block'),
      equipmentNo: document.getElementById('equipmentNo').value,
      equipmentTrailerNo: getSelectedValue('equipmentTrailerNo'),
      differential: getSelectedValue('differential'),
      workPerformed: $.trim(document.getElementById('workPerformed').value),
      detail: document.getElementById('detail').value,
      hours,
      trainer
    });
    document.getElementById("second-ts-form").reset();
  }
  /* Cap dates after 10am for new PP */
  let startDate;
  let lastDay = moment().format('YYYY-MM-DD');
  // Proposed 9.3.21 to change to 5 days instead of 3 for retroactive submission
  let lastDayForAdmins = moment(prevPPEndDate).add(5, 'days').format('YYYY-MM-DD');
  if (lastDay === payPeriodStartDate && moment().hour() < 10) startDate = prevPPStartDate;
  else startDate = payPeriodStartDate;
  if (lastDayForAdmins >= lastDay && user.level === 4) startDate = prevPPStartDate;
  // If nec. to create timesheets beyond end of pp
  //startDate = moment(prevPPStartDate).subtract(DAYS_FOR_ADMINS, 'days').format('YYYY-MM-DD')
  return (
      <div>
        <form onSubmit={(e) => e.preventDefault()} id="basic-ts-form" className="form-rerender">
          <div className="row">
            <div className="col s12 m12 l4 xl4">
              <DatePicker2 id={'date'} label={'Date'} min={startDate} max={payPeriodEndDate} />
            </div>
            <div className="col s12 m12 l4 xl4">
              <Select id={'location'} opts={LOCATIONS} label={'Location'} onChange={(e) => { fetchFieldsByLoc(e.target.value); selectCostCenterByLocation(e.target.value) }} />
            </div>
            <div className="col s12 m12 l4 xl4">
              <TextInput id={'regGangNo'} label={'Team No.'} />
            </div>
          </div>
          <div className="row">
            <div className="col s12 m12 l4 xl4">
              <TimePicker2 id={'startTime'} label={'Start Time'} defaultValue={'07:00'} />
            </div>
            <div className="col s12 m12 l4 xl4">
              <TimePicker2 id={'endTime'} label={'End Time'} defaultValue={'15:30'} />
            </div>
            <div className="col s12 m12 l4 xl4">
              <Select id={'shift'} opts={SHIFTS} label={'Shift'} />
            </div>
          </div>
          <div className="row">
            <div className="col s12 m12 l12 xl12">
              <input type="checkbox" id="dustPay" />
              <label htmlFor="dustPay">Dust Pay</label>
            </div>
          </div>
        </form>
        <hr />
        <center>
          <p className="flow-text">Individual Work Form</p>
        </center>
        <hr />
        <form onSubmit={(e) => e.preventDefault()} id="second-ts-form" >
          <div className="row">
            <div className="col s12 m12 l4">
              <Select
                id={'tempGrade'}
                opts={GRADES}
                label={'Temp Grade'}
              />
            </div>
            <div className="col s12 m12 l4">
              <SelectCostCenter
                id={'costCenterCode'}
                opts={costCenters}
                label={'Cost Center'}
                onChange={(e) => fetchSubAccounts(e.target.value)}
              />
            </div>
            <div className="col s12 m12 l4">
              <SelectSubAccount
                id={'subAccount'}
                opts={subAccounts}
                label={'Sub Account'}
                onChange={(e) => setCCSubInWorkPerformed('workPerformed', 'costCenterCode', e.target.id)}
              />
            </div>
          </div>
          <div className="row">
            <div className="col s12 m12 l3 xl3">
              <Select id={'paycode'}
                opts={paycodes.map((p) => { return { val: p.code, label: p.label } })}
                label={'Special Pay Code'}
                onChange={(e) => setPaycodeInWorkPerformed('workPerformed', e.target.id)}
              />
            </div>
            <div className="col s12 m12 l3 xl3">
              <SelectField
                id={'field'}
                label={'Field No.'}
                opts={fields}
                onChange={(e) => fetchBlocksByField(e.target.value)}
              />
            </div>
            <div className="col s12 m12 l3 xl3">
              <SelectBlock id={`block`} label={'Block No.'} opts={blocks} />
            </div>
            <div className="col s12 m12 l3 xl3">
              <Select id={'detail'} opts={details.map((d) => { return { val: d.detail, label: `${d.detail} - ${d.description}` } })} label={'Detail'} />
            </div>
          </div>
          <div className="row">
            <div className="col s12 m12 l3 xl3">
              <AutoComplete id={'equipmentNo'} label={'Equipment No.'}
                data={mapEquipmentForAutoComplete(equipmentNo)} onComplete={onDummyComplete}  />
            </div>
            <div className="col s12 m12 l3 xl3">
              <SelectEquipment id={'equipmentTrailerNo'} opts={equipmentTrailerNo} label={'Equipment Trailer No.'} />
            </div>
            <div className="col s12 m12 l3 xl3">
              <Select id={'differential'} label={'Differential'} opts={DIFFERENTIAL_SLOT} />
            </div>
            <div className="col s12 m12 l3 xl3">
              <p className="trainer"><input type="checkbox" id="trainer" />
              <label htmlFor="trainer">Trainer</label></p>
            </div>
          </div>
          <div className="row">
            <div className="col s12 m12 l8">
              <TextInput id={'workPerformed'} label={'Work Performed'} placeholder={'Ex: Blow/sweep, Hauling, Vacation, Sick'} />
            </div>
            <div className="col s12 m12 l4">
              <NumberInput id={'hours'} min={"0"} max={"16"} label={'Hours'} step={"0.1"} />
            </div>
            <div className="col s12 m12 l2">
              <button onClick={() => packageWorkPerformed(addWork)} className="btn waves-effect waves-light">Add Work</button>
            </div>
            <div className="col s12 m12 l2">
              <button id={'ind-work-edit-btn'} onClick={() => packageWorkPerformed(editWorkRecord)} className="btn waves-effect waves-light blue">Edit Work</button>
            </div>
          </div>
          <div className="row">
            <div className="col s12 m12 l12">
              <WorkTable work={workPerformed} removeWork={removeWork} editWork={editWork} />
            </div>
          </div>
        </form>
      </div>
  );
};

export default TimesheetForm;



















/* END */



// WEBPACK FOOTER //
// ./src/components/timesheets/create/timesheet_form.js